import { RootState } from '../Store';
export const selectContent = (state: RootState) => state.Content;